import axios from "axios";
export const apiURL = "https://shop.l2w.kz/backend/"

export default axios.create({
    baseURL: apiURL
})


